module.exports = __webpack_public_path__ + "2fdc8dae2f4c1857c0a3d5d431c0a701.MP3";